import { render, staticRenderFns } from "./ProjectConfigurationMenu.vue?vue&type=template&id=2617796c&scoped=true&"
import script from "./ProjectConfigurationMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationMenu.vue?vue&type=style&index=0&id=2617796c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617796c",
  null
  
)

export default component.exports